<template>
	<v-dialog
		v-model="dialog"
		:max-width="dialogWidth"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">インポート元製品検索</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark @click="dialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>

			<v-form class="pa-2" ref="form" @submit.prevent>
				<p class="caption">※一括取得できる件数は最大２０件までです</p>
				<v-row v-if="searchedOrderedProducts" align="center" justify="space-around" no-gutters>
					<v-text-field
						type="text"
						v-model="searchWord"
						class="mt-2 mx-1"
						label="製造番号"
						outlined
						dense
					/>
				</v-row>
				<p class="secondary--text text-center" v-if="noResultFlag">該当するデータはありません</p>

				<v-row no-gutters align="center" justify="space-around">
					<v-btn
						class="mt-2 mx-1"
						:disabled="!searchWord"
						@click="searchOrderedProducts(searchWord)"
						><v-icon>mdi-magnify</v-icon>検索</v-btn
					>
				</v-row>
			</v-form>
			<v-row no-gutters justify="space-around"
				><v-btn
					class="ma-2 pa-2 pre-wrap height100p text-align-left"
					v-for="orderedProduct in searchedOrderedProducts"
					:key="orderedProduct.id"
					v-text="orderedProductInfo(orderedProduct)"
					@click="setOrderedProduct(orderedProduct)"
				></v-btn
			></v-row>
			<v-row no-gutters class="pa-2" justify="space-around" v-if="selectedOrderedProduct">
				<table>
					<thead>
						<tr>
							<th>品番</th>
							<th>品名</th>
							<th>数量</th>
							<th>単価</th>
							<th>備考</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="oc in selectedOrderedProduct.order_components" :key="oc.id">
							<td>{{ oc.component.part_number }}</td>
							<td>{{ oc.component.name }}</td>
							<td>{{ oc.quantity }}</td>
							<td>{{ oc.unit_price ? oc.unit_price.toLocaleString() : "" }}</td>
							<td>{{ oc.remarks }}</td>
						</tr>
					</tbody>
				</table>
			</v-row>
			<v-row no-gutters class="pa-2" justify="space-around" v-if="selectedOrderedProduct">
				<v-btn class="mt-2 mx-1" @click="createOrderComponents()"
					><v-icon>mdi-set-merge</v-icon>上記の部品をインポートする</v-btn
				>
				<v-btn class="mt-2 mx-1" @click="cancel()"><v-icon>mdi-close</v-icon>キャンセル</v-btn>
			</v-row>
			<v-card-actions>
				<v-row no-gutters class="pb-2"> </v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import common from "../../../helper/common"

import rules from "../../../helper/rules"

export default {
	data() {
		return {
			dialogWidth: "600px",
			common: common,
			dialog: false,
			noResultFlag: false,
			searchWord: null,
			targetOrderedProductId: null,
			searchedOrderedProducts: [],
			selectedOrderedProduct: null,
		}
	},
	methods: {
		cancel() {
			this.selectedOrderedProduct = null
		},
		orderedProductInfo(op) {
			return (
				"製造番号：" +
				op.product_number +
				"\n製品名　：" +
				op.product.name +
				"\n数量　　：" +
				op.quantity
			)
		},
		openDialog(id) {
			this.dialog = true
			this.targetOrderedProductId = id
		},
		closeDialog() {
			this.dialog = false
			this.targetOrderedProductId = null
			this.searchedOrderedProducts = []
			this.selectedOrderedProduct = null
			this.$emit("reloadOrderComponents")
		},
		createOrderComponents() {
			const headers = authenticate.setHeader()
			const formData = new FormData()
			const config = { headers: { "content-type": "multipart/form-data" } }
			formData.append("ordered_product_id", this.targetOrderedProductId)
			formData.append("selected_ordered_product_id", this.selectedOrderedProduct.id)
			axios
				.post("/erp/v1/parts_list/copy_order_components.json", formData, { headers })
				.then((response) => {
					this.$store.commit("setFlash", {
						text: response.data.correct_number + "件の部品をインポートしました",
						type: "notice",
					})
					if (response.data.error_number) {
						this.$store.commit("setFlash", {
							text: response.data.error + "件のインポートに失敗しました",
							type: "alert",
						})
					}
					this.closeDialog()
				})
				.catch((err) => {
					console.log(err)
					errorHandling.errorResponse(err)
				})
		},
		searchOrderedProducts() {
			let th = this
			async function main() {
				let response = await th.common.searchOrderedProducts(th.searchWord)
				th.searchedOrderedProducts = response.data.ordered_products
				if (th.searchedOrderedProducts.length == 0) {
					th.noResultFlag = true
				} else {
					th.noResultFlag = false
				}
			}
			main()
		},
		setOrderedProduct(orderedProduct) {
			this.selectedOrderedProduct = orderedProduct
			this.searchedOrderedProducts = []
			this.searchWord = ""
		},
	},
	watch: {
		statusIdsHash() {
			if (this.statusIdsHash != null) {
				let keys = Object.keys(this.statusIdsHash)
				keys.forEach((key) => {
					this.statusAndJapanese.push({
						text: this.statusIdsHash[key],
						value: key,
					})
				})
			}
		},
	},
	computed: {},
}
</script>
<style lang="scss" scoped>
@import "../../../stylesheet/variable.scss";

table {
	border-collapse: separate;
	text-align: center;
	max-height: 1000px;
}
th,
td {
	border: 1px gray solid;
	padding: 3px;
	background: white;
}
tr {
	border-bottom: solid 1px gray;
}
th {
	background-color: $sub-color;
	color: #fff;
	min-width: 110px;
	text-align: center;
	position: sticky;
	top: 0;
}
</style>
